import {combineReducers} from "redux";

import bookDetailsState from './book_details/reducers';
import cartItemsState from './cart/reducers';
import bookTagsState from './book_tags/reducers';
/*import makesState from './makes/reducers';
import modelsState from './models/reducers';
import suppliersState from './suppliers/reducers';*/

export default combineReducers({bookDetailsState, cartItemsState, bookTagsState});